// extracted by css-extract-rspack-plugin
export default {"contentWrapper":"CodeView-module__contentWrapper__cG2JH"};